import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionTypes } from "../constants/action-types";
import { smartMovingApiCall } from "../../api/smartMoving";
import { apiCall } from "../../api/api";
import axios from "axios";

export const createCustomer = createAsyncThunk(
  ActionTypes.CREATE_CUSTOMER,
  async (createCustomer: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `smart-moving/create-smart-movig-user`,
        "post",
        createCustomer
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createOpportunity = createAsyncThunk(
  ActionTypes.CREATE_OPPORTUNITY,
  async (opportunityPayload: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `smart-moving/create-opportunity`,
        "post",
        opportunityPayload
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const addInventoryToOpportunity = createAsyncThunk(
  ActionTypes.ADD_INVENTORY_TO_OPPORTUNITY,
  async (
    {
      opportunityId,
      roomId,
    }: {
      opportunityId: string;
      roomId: string;
      // items: CustomItemModel[];
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await smartMovingApiCall({
        url: `/premium/opportunities/${opportunityId}/inventory/rooms/${roomId}`,
        method: "POST",
        // data: { items },
        contentType: "application/json-patch+json",
      });
      return response; // Array of added inventory items
    } catch (error: any) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const saveSmartMovingResponse = createAsyncThunk(
  ActionTypes.SAVE_SMART_MOVING_RESPONSE,
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(`smart-moving/create`, "post", data);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const createRooms = createAsyncThunk(
  ActionTypes.CREATE_ROOMS,
  async (
    {
      carrierId,
      opportunityId,
      rooms,
    }: {
      carrierId: number;
      opportunityId: string;
      rooms: Array<{ name: string; roomTypeId: string }>;
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(
        `smart-moving/rooms-in-opportunities/${opportunityId}/rooms`,
        "post",
        { rooms, carrierId }
      );
      return res;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const createJob = createAsyncThunk(
  ActionTypes.CREATE_JOB,
  async (
    {
      opportunityId,
      jobData,
    }: {
      opportunityId: string;
      jobData: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(
        `smart-moving/job/${opportunityId}/jobs`,
        "post",
        jobData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const confirmJob = createAsyncThunk(
  ActionTypes.CONFIRM_JOB,
  async (
    {
      opportunityId,
      currentJobId,
      carrierId,
    }: {
      opportunityId: string;
      currentJobId: string;
      carrierId: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(
        `smart-moving/confirm-job/${opportunityId}/jobs/${currentJobId}`,
        "post",
        { carrierId }
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const createLogNotesInOpportunity = createAsyncThunk(
  ActionTypes.CREATE_LOG_NOTES_OPPORTUNITY,
  async (
    {
      carrierId,
      opportunityId,
      notes,
    }: {
      carrierId: number;
      opportunityId: string;
      notes: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(`smart-moving/notes/${opportunityId}`, "post", {
        notes,
        carrierId,
      });
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

// actions.ts

export const getReferralSources = createAsyncThunk(
  ActionTypes.GET_REFERRAL_SOURCE_ID,
  async (carrierId: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `smart-moving/referral-sources/${carrierId}?page=0&pageSize=20`,
        "get"
      );
      return res;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getBranches = createAsyncThunk(
  ActionTypes.GET_BRANCHE_ID,
  async (carrierId: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `smart-moving/branches/${carrierId}?page=0&pageSize=20`,
        "get"
      );
      return res;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTariffs = createAsyncThunk(
  ActionTypes.GET_BRANCHE_ID,
  async (carrierId: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `smart-moving/tariffs/${carrierId}?page=0&pageSize=20`,
        "get"
      );
      return res;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getMoveSizes = createAsyncThunk(
  ActionTypes.GET_MOVE_SIZE_ID,
  async (carrierId: number, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `smart-moving/move-sizes/${carrierId}?page=0&pageSize=20`,
        "get"
      );
      return res;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
